var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenshot(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.3333C14.795 17.3333 16.25 15.8782 16.25 14.0833C16.25 12.2883 14.795 10.8333 13 10.8333C11.205 10.8333 9.75 12.2883 9.75 14.0833C9.75 15.8782 11.205 17.3333 13 17.3333Z",
    stroke: "#717784",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 18.1999V9.96658C3.25 8.75314 3.25 8.14641 3.48616 7.68294C3.69387 7.27525 4.02533 6.94379 4.43302 6.73607C4.89649 6.49992 5.50322 6.49992 6.71667 6.49992H7.85919C7.99238 6.49992 8.05897 6.49992 8.12041 6.49288C8.44097 6.45616 8.72847 6.27847 8.90466 6.00818C8.93843 5.95638 8.96822 5.89681 9.02777 5.77769C9.1469 5.53946 9.20646 5.42033 9.27401 5.31672C9.62639 4.77614 10.2014 4.42076 10.8425 4.34732C10.9654 4.33325 11.0985 4.33325 11.3649 4.33325H14.6351C14.9015 4.33325 15.0346 4.33325 15.1575 4.34732C15.7986 4.42076 16.3736 4.77614 16.726 5.31672C16.7935 5.42032 16.8531 5.53949 16.9723 5.77769C17.0317 5.89682 17.0615 5.95638 17.0953 6.00818C17.2716 6.27847 17.559 6.45616 17.8796 6.49288C17.9411 6.49992 18.0076 6.49992 18.1408 6.49992H19.2833C20.4968 6.49992 21.1036 6.49992 21.567 6.73607C21.9747 6.94379 22.3062 7.27525 22.5138 7.68294C22.75 8.14641 22.75 8.75314 22.75 9.96658V18.1999C22.75 19.4134 22.75 20.0201 22.5138 20.4836C22.3062 20.8912 21.9747 21.2227 21.567 21.4304C21.1036 21.6666 20.4968 21.6666 19.2833 21.6666H6.71667C5.50322 21.6666 4.89649 21.6666 4.43302 21.4304C4.02533 21.2227 3.69387 20.8912 3.48616 20.4836C3.25 20.0201 3.25 19.4134 3.25 18.1999Z",
    stroke: "#717784",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.38376044baf0c08342cdcfa193e1a975.svg";
export { ForwardRef as ReactComponent };